import { Modal } from "@circle-react-uikit/ModalV2";
import { useEffect } from "react";
import type { ReactNode } from "react";

import type { UpgradePlanHeaderConfig } from "./UpgradePlanModalConfigContext";
import { useSetUpgradePlanModalHeader } from "./UpgradePlanModalConfigContext";

interface UpgradePlanModalHeaderProps extends UpgradePlanHeaderConfig {
  children: ReactNode;
}

export const UpgradePlanModalHeader = ({
  title,
  children,
}: UpgradePlanModalHeaderProps) => {
  const setHeaderConfig = useSetUpgradePlanModalHeader();

  useEffect(() => {
    if (setHeaderConfig) {
      setHeaderConfig({ title });
    }
  }, [setHeaderConfig, title]);

  useEffect(
    () => () => {
      setHeaderConfig?.(null);
    },
    [setHeaderConfig],
  );

  if (setHeaderConfig) {
    return null;
  }

  return <Modal.Header>{children}</Modal.Header>;
};
